import { IPriceGroup } from 'core/model/interfaces/master-entities';
import type { TSliceReducer } from 'core/store';
import { initialState } from './constants';
import type { IPricesState } from './types';

export const clearPricesState: TSliceReducer<IPricesState> = state => {
  Object.assign(state, initialState);
};

export const setPrices: TSliceReducer<IPricesState, Array<IPriceGroup>> = (state, { payload }) => {
  state.priceGroups = payload;
};

export const reducers = { clearPricesState, setPrices };
